<template>

    <div></div>
   
</template>

<script>

//Log out
import {
    logout
} from "@/components/auth/AuthService.js"

import {
  redirectState
} from "@/UrlService.js"

export default{

    //On mounted execute logout
    mounted(){
        var state = this.$route.query["state"]
        if(state === undefined){
            state = redirectState()
        }
        logout(state)
    }   

}
</script>

<style scoped>
</style>